<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <create-index></create-index>
    </div>
  </div>
</template>

<script>

import CreateIndex from "../../components/CreateIndex.vue";

export default {
  components: {
    CreateIndex
  },
  name: "Index",
  data() {
    return {
      categorey: []
    };
  },
  methods: {},
  mounted() {},
  created() {}
};
</script>
<style>
</style>
